import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { LocaleService } from '@shared/services/locale.service';
import { ApiService } from '@shared/services/api.service';
import { AuthService } from '@shared/services/auth.service';
import { SnackService } from '@shared/services/snack.service';
import { User } from '@core/models';
import { AdsApi } from '@core/apis/ads.api';

@Component({
	selector: 'app-payment-success',
	templateUrl: './payment-success.component.html',
	styleUrls: ['./payment-success.component.scss'],
})
export class PaymentSuccessComponent implements OnInit {
	constructor(
		private route: ActivatedRoute,
		private title: Title,
		public locale: LocaleService,
		private api: ApiService,
		private auth: AuthService,
		private snack: SnackService,
		private adsApi: AdsApi
	) {}

	embedded: boolean = false;
	errorScreen: boolean = false;
	adID: string;
	package: string;
	tokenID: any;
	user: User = this.auth.user();
	loading: boolean = false;

	getDetails() {
		this.loading = true;
		const formData: FormData = new FormData();
		formData.append('lang', this.locale.lang);
		formData.append('tokenID', this.tokenID);

		this.api.verifyPayment(formData).subscribe((res) => {
			if (res.status === '1') {
				this.adsApi.upgradeAd.next(true);
				this.adID = res.response.adID;

				this.api.upgradeAd(formData).subscribe((res) => {
					if (res.status === '1') {
						if (this.embedded) {
							this.auth.logout();
							this.loading = false;
						}
					}
				});

				this.loading = false;
			} else {
				this.errorScreen = true;
				this.loading = false;
				this.snack.open(this.locale.translations['misc']['n174']);
			}
		});
	}

	ngOnInit(): void {
		this.route.queryParams.subscribe((queries: Params) => {
			if (queries['adID']) {
				this.adID = queries['adID'];
			}

			if (queries['package']) {
				this.package = queries['package'];
			}

			if (queries['embedded']) {
				this.embedded = queries['embedded'];
			}

			if (queries['tokenID']) {
				this.tokenID = queries['tokenID'];
				this.getDetails();
			}
		});

		this.title.setTitle(this.locale.translations['payment']['n344'] + ' | ' + this.locale.translations['header']['n0']);
	}
}
